var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwarenessActions } from '../actions/index';
export var initialState = {
    basin: '',
    tab: 'Basin'
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case AwarenessActions.AwarenessActions.SetBasin: {
            return __assign({}, state, { basin: action.payload });
        }
        case AwarenessActions.AwarenessActions.SetTab: {
            return __assign({}, state, { tab: action.payload });
        }
        default:
            return state;
    }
}
